import React from 'react';
import { Menu } from 'lucide-react';
import './Header.css';

const Header = ({ sidebarOpen, setSidebarOpen }) => {
  return (
    <div className="header-container">
      <h1 className="header-title">Bioinformatics</h1>
      <button
        className="header-menu-button"
        onClick={() => setSidebarOpen(!sidebarOpen)}
      >
        <Menu size={24} />
      </button>
    </div>
  );
};

export default Header;
